import { connect } from 'react-redux';
import ContentSection from './pure';

const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = (dispatch) => ({

})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentSection);



// WEBPACK FOOTER //
// ./src/components/ContentSection/connected.js